import { useEffect, useState } from 'react';
import { View } from 'foundations-components/components/View';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { stringify } from 'hub-http/helpers/params';
import getUserInfo from 'hub-http/userInfo';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_PARAMS = {
  embed: true
};
const getInlineMeetingParams = ({
  apiName,
  userInfo,
  repInfo,
  trackingData
}) => {
  const hasAssignedRep = !!(repInfo && repInfo.link);
  const attributionSource = hasAssignedRep ? 'rep' : 'ISC';
  const meetingParams = {
    meeting_funnel: 'in-app',
    meeting_medium: 'pql',
    meeting_product: ApiNameToUpgradeProductMap[apiName],
    meeting_source: `${trackingData.app}-${trackingData.screen}-contact-sales-button-${trackingData.uniqueId}`,
    meeting_type: attributionSource,
    meeting_campaign: attributionSource
  };
  return stringify(Object.assign({
    firstName: userInfo.user.first_name,
    lastName: userInfo.user.last_name,
    email: userInfo.user.email,
    // @ts-expect-error domain is not defined in type Portal
    // portal.domain is deprecated and we should get rid of this
    website: userInfo.portal.domain
  }, meetingParams, BASE_PARAMS));
};
const StyledIframe = styled.iframe.withConfig({
  displayName: "MeetingModal__StyledIframe",
  componentId: "sc-166mo8l-0"
})(({
  theme
}) => ({
  border: theme.space['0'],
  width: '900px',
  height: '800px'
}));
export const MeetingModal = ({
  apiName,
  onClose,
  repInfo,
  trackingData
}) => {
  const [userInfo, setUserInfo] = useState(null);
  const {
    link: linkBase
  } = repInfo;
  useEffect(() => {
    getUserInfo().then(response => {
      setUserInfo(response);
    }).catch(() => {});
  }, []);
  if (userInfo) {
    const meetingLink = `${linkBase}?${getInlineMeetingParams({
      apiName,
      repInfo,
      userInfo,
      trackingData
    })}`;
    return /*#__PURE__*/_jsx(Modal, {
      use: "conversational",
      width: 900,
      children: /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-tertiary-default",
        paddingBlockStart: "1500",
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => onClose()
        }), /*#__PURE__*/_jsx(StyledIframe, {
          id: "meetingModal",
          "data-test-id": "tts-modal",
          src: meetingLink
        })]
      })
    });
  }
};